<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="8">
        <v-card>
          <v-card-title>Catégories</v-card-title>
          <v-card-text>
            <v-chip
              class="ma-2"
              :close="!category.count && admin"
              @click="openForm('categories', { ...category })"
              @click:close="openDeleteDialog('categories', { ...category })"
              v-for="category in categories"
              :key="category._id"
            >
              <v-avatar left class="grey lighten-1 small-caption">{{
                category.count
              }}</v-avatar>
              {{ category.name }}
            </v-chip>
            <v-btn
              color="secondary"
              fab
              x-small
              text
              @click="openForm('categories', {})"
              v-if="admin"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="8">
        <v-card>
          <v-card-title>Centre de coûts</v-card-title>
          <v-card-text>
            <v-chip
              class="ma-2"
              :close="!costCenter.count && admin"
              @click:close="openDeleteDialog('costCenters', { ...costCenter })"
              @click="openForm('costCenters', { ...costCenter })"
              v-for="costCenter in costCenters"
              :key="costCenter._id"
            >
              <v-avatar left class="grey lighten-1 small-caption">{{
                costCenter.count
              }}</v-avatar>
              {{ costCenter.name }}
            </v-chip>
            <v-btn
              color="secondary"
              fab
              x-small
              text
              @click="openForm('costCenters', {})"
              v-if="admin"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="8">
        <v-card>
          <v-card-title>Emplacements</v-card-title>
          <v-card-text>
            <v-chip
              class="ma-2"
              :close="!place.count && admin"
              @click:close="openDeleteDialog('places', { ...place })"
              @click="openForm('places', { ...place })"
              v-for="place in places"
              :key="place._id"
            >
              <v-avatar left class="grey lighten-1 small-caption">{{
                place.count
              }}</v-avatar>
              {{ place.name }}
            </v-chip>
            <v-btn
              color="secondary"
              fab
              x-small
              text
              @click="openForm('places', {})"
              v-if="admin"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="8">
        <v-card>
          <v-card-title>Entités</v-card-title>
          <v-card-text>
            <v-chip
              class="ma-2"
              :close="!entity.count && admin"
              @click:close="openDeleteDialog('entities', { ...entity })"
              @click="openForm('entities', { ...entity })"
              v-for="entity in entities"
              :key="entity._id"
            >
              <v-avatar left class="grey lighten-1 small-caption">{{
                entity.count
              }}</v-avatar>
              {{ entity.name }}
            </v-chip>
            <v-btn
              color="secondary"
              fab
              x-small
              text
              @click="openForm('entities', {})"
              v-if="admin"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="8">
        <v-card>
          <v-card-title>Raisons de sortie</v-card-title>
          <v-card-text>
            <v-chip
              class="ma-2"
              :close="!inventoryDeletionCause.count && admin"
              @click:close="
                openDeleteDialog('inventoryDeletionCauses', {
                  ...inventoryDeletionCause,
                })
              "
              @click="
                openForm('inventoryDeletionCauses', {
                  ...inventoryDeletionCause,
                })
              "
              v-for="inventoryDeletionCause in inventoryDeletionCauses"
              :key="inventoryDeletionCause._id"
            >
              <v-avatar left class="grey lighten-1 small-caption">{{
                inventoryDeletionCause.count
              }}</v-avatar>
              {{ inventoryDeletionCause.name }}
            </v-chip>
            <v-btn
              color="secondary"
              fab
              x-small
              text
              @click="openForm('inventoryDeletionCauses', {})"
              v-if="admin"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-form ref="form" v-model="valid">
      <params-form
        :dialog="paramForm"
        :type="type"
        :displaySnackbar="displaySnackbar"
        :closeDialog="closeDialog"
        :updateParam="updateParam"
        :payload="payload"
        :entities="entities"
        :costCenters="costCenters"
        :admin="admin"
      />
    </v-form>
    <v-snackbar
      v-model="snackbar.visible"
      :bottom="true"
      :left="true"
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <v-btn dark text @click="snackbar.visible = false">Fermer</v-btn>
    </v-snackbar>
    <v-dialog v-model="deleteDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Suppression d'un paramètre</span>
        </v-card-title>
        <v-card-text>
          <p>
            Voulez-vous vraiment supprimer définitivement le paramètre suivant :
          </p>
          <ul>
            <li>{{ payload.name }}</li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteDialog = false"
            >Annuler</v-btn
          >
          <v-btn color="error" text @click="deleteParamAsync">Supprimer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ParamsForm from "@/components/ParamsForm";
import dashify from "dashify";
import axios from "axios";
export default {
  props: [
    "categories",
    "costCenters",
    "entities",
    "inventoryDeletionCauses",
    "places",
    "updateParam",
    "deleteParam",
    "admin",
  ],
  data: () => ({
    valid: true,
    paramForm: false,
    deleteDialog: false,
    type: undefined,
    payload: {},
    snackbar: {
      visible: false,
      text: "",
      color: "",
    },
  }),
  components: {
    ParamsForm,
  },
  methods: {
    openForm: function (type, payload) {
      this.paramForm = true;
      this.type = type;
      this.payload = payload;
    },
    openDeleteDialog: function (type, payload) {
      this.deleteDialog = true;
      this.payload = payload;
      this.type = type;
    },
    displaySnackbar: function (snackbar) {
      this.closeDialog();
      this.snackbar = snackbar;
    },
    closeDialog: function () {
      this.paramForm = false;
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
    deleteParamAsync: async function () {
      try {
        await axios({
          method: "DELETE",
          url: `${process.env.VUE_APP_API_URI}/${dashify(this.type)}/${
            this.payload._id
          }`,
        });
        this.deleteParam(this.type, this.payload._id);
        this.displaySnackbar({
          visible: true,
          text: "Paramètre supprimé",
          color: "success",
        });
        this.deleteDialog = false;
      } catch (error) {
        this.displaySnackbar({
          visible: true,
          text: "Erreur de suppression",
          color: "error",
        });
      }
    },
  },
};
</script>

<style scoped>
.small-caption {
  font-size: 7pt !important;
}
</style>